import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface OtpVerificationData {
  phoneNumber: string;
  countryCode?: string;
  fullName: string;
  dob?: string;
  gender?: string;
  profileImage?: string;
  isNewUser: boolean;
  flowType: "login" | "register" | "updateMobile";
  rememberMe?: boolean;
}

interface PhoneUpdateVerificationData {
  phoneNumber: string;
  countryCode?: string;
  verifiedAt: number;
}

interface AuthState {
  otpVerification: OtpVerificationData | null;
  phoneUpdateVerification: PhoneUpdateVerificationData | null;
  emailVerification: string | null;
}

const initialState: AuthState = {
  otpVerification: null,
  phoneUpdateVerification: null,
  emailVerification: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setOtpVerificationData(state, action: PayloadAction<OtpVerificationData>) {
      state.otpVerification = action.payload;
    },
    clearOtpVerificationData(state) {
      state.otpVerification = null;
    },
    setPhoneUpdateVerificationData(state, action: PayloadAction<Omit<PhoneUpdateVerificationData, "verifiedAt">>) {
      state.phoneUpdateVerification = {
        ...action.payload,
        verifiedAt: Date.now(),
      };
    },
    clearPhoneUpdateVerificationData(state) {
      state.phoneUpdateVerification = null;
    },
    setEmailVerification(state, action: PayloadAction<string>) {
      state.emailVerification = action.payload;
    },
    clearEmailVerification(state) {
      state.emailVerification = null;
    },
  },
});

export const {
  setOtpVerificationData,
  clearOtpVerificationData,
  setPhoneUpdateVerificationData,
  clearPhoneUpdateVerificationData,
  setEmailVerification,
  clearEmailVerification,
} = authSlice.actions;
export default authSlice.reducer;
